import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import fecha from 'fecha';
import './styles.scss';
import timeIcon from '../../images/timeImg@3x.png';
import isWebSite, { getUrl } from '../../utils/isWebSite';
import { debounce } from '../../utils/debounce';
import { getTimesheetList } from '../../actions/actions';

const parseDate = date => {
  const parseTime = fecha.parse(date, 'YYYY-MM-DD');
  return fecha.format(parseTime, 'MMM DD YYYY');
};

const parseTime = time => {
  const parseTime = fecha.parse(time, 'HH:mm:ss');
  return fecha.format(parseTime, 'HH:mm');
};

class TimesheetList extends React.Component {
  constructor() {
    super();
    this.handleVisible = this.handleVisible.bind(this);
    this.handleNewTimesheetTouch = debounce(
      this.handleNewTimesheetTouch.bind(this),
      300,
      true
    );
  }

  componentDidMount() {
    this.props.dispatch(getTimesheetList());
    this.pollUpdates();
    document.addEventListener('visibilitychange', this.handleVisible, false);
  }

  handleVisible() {
    if (!document.hidden) {
      this.props.dispatch(getTimesheetList());
    }
  }

  pollUpdates() {
    this.pollTimer = setInterval(() => {
      if (!document.hidden) {
        this.props.dispatch(getTimesheetList());
      }
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.pollTimer);
    document.removeEventListener('visibilitychange', this.handleVisible, false);
  }

  handleNewTimesheetTouch(e) {
    e.preventDefault();
    if (isWebSite()) {
      this.props.history.push(getUrl('new_timesheet'));
    } else {
      window.location = 'https://url/new_timesheet';
    }
  }

  render() {
    const { timesheets } = this.props;

    const list = timesheets
      ? timesheets
      : [
          {
            id: 1,
            firstName: 'x',
            lastName: 'x',
            status: ' x',
            startTime: '11:00:00',
            endTime: '11:00:00',
            date: '2000-01-01'
          },
          {
            id: 2,
            firstName: 'x',
            lastName: 'x',
            status: ' x',
            startTime: '11:00:00',
            endTime: '11:00:00',
            date: '2000-01-01 '
          }
        ];

    return (
      <div>
        <div className="timesheets__row timesheets__row--inline-button">
          <button
            className="button button--inline"
            onTouchStart={this.handleNewTimesheetTouch}
            onMouseDown={this.handleNewTimesheetTouch}
          >
            Add New Session
          </button>
        </div>
        <ul
          className={`timesheets__row timesheets__list${
            !timesheets ? ' timesheets__row--loading' : ''
          }`}
        >
          {list.map(item => (
            <li key={item.id}>
              <div>
                <div>
                  {item.firstName} {item.lastName}
                </div>
                <div
                  className={`timesheets__status timesheets__status--${item.status}`}
                >
                  {item.status}
                </div>
              </div>
              <div>
                <div>{parseDate(item.date)}</div>
                <div className="timesheets__time">
                  <img src={timeIcon} alt="" />
                  {parseTime(item.startTime)} - {parseTime(item.endTime)}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default connect(state => ({
  timesheets: state.timesheetList
}))(withRouter(TimesheetList));
